import { useRouter } from "next/router";
import Link from "next/link";
import styles from "./styles.module.scss";

const Breadcrumb = ({ customBreadcrumbs = {}, overrideBreadcrumbs = null }) => {
  const router = useRouter();
  const { asPath, pathname, query } = router;

  // 1. Full override support
  if (Array.isArray(overrideBreadcrumbs)) {
    return (
      <nav className={styles.breadcrumb}>
        <ul>
          {overrideBreadcrumbs.map((crumb, index) => (
            <li key={index}>
              <Link href={crumb.href}>{crumb.label}</Link>
            </li>
          ))}
        </ul>
      </nav>
    );
  }

// 2. Handle special case for /product/[id] with productData passed in customBreadcrumbs
if (pathname.startsWith("/product/") && query.slug?.[0]) {
  const breadcrumbs = [{ href: "/shop", label: "Shop" }];

  const productData = customBreadcrumbs.productData;
  if (productData) {
    const { kind, root_subtype, name, brand } = productData;

    // if (brand) {
    //   const brandSlug = brand.toLowerCase().replace(/\s+/g, "-");
    //   breadcrumbs.push({
    //     href: `/brands/${brandSlug}`,
    //     label: brand,
    //   });
    // }

    if (kind) {
      const kindSlug = kind.toLowerCase().replace(/\s+/g, "-");
      breadcrumbs.push({
        href: `/shop/${kindSlug}`,
        label: kind,
      });

      if (root_subtype) {
        const subtypeSlug = root_subtype.toLowerCase().replace(/\s+/g, "+");
        breadcrumbs.push({
          href: `/shop/${kindSlug}?subcategory=${kindSlug}:${subtypeSlug}`,
          label: root_subtype,
        });
      }
    }

    // Final crumb: product name (not a link)
    breadcrumbs.push({
      href: asPath,
      label: name || "Product",
    });
  }

  return (
    <nav className={styles.breadcrumb}>
      <ul>
        {breadcrumbs.map((crumb, index) => (
          <li key={index}>
            {index === breadcrumbs.length - 1 ? (
              <span aria-current="page">{crumb.label}</span>
            ) : (
              <Link href={crumb.href}>{crumb.label}</Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}


  // 3. Default behavior for all other routes
  const breadcrumbs = [{ href: "/", label: "Home" }];
  const pathSegments = asPath.split("?")[0].split("/").filter(Boolean);

  pathSegments.forEach((segment, index) => {
    const href = `/${pathSegments.slice(0, index + 1).join("/")}`;

    // Replace dynamic segments like [slug] with actual value from query
    const isDynamic = segment.startsWith("[") && segment.endsWith("]");
    const dynamicKey = segment.slice(1, -1);
    const actualSegment = isDynamic && query[dynamicKey] ? query[dynamicKey] : segment;

    const defaultLabel = actualSegment
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

    const label = customBreadcrumbs[href] || defaultLabel;

    breadcrumbs.push({ href, label });
  });

  return (
    <nav className={styles.breadcrumb}>
      <ul>
        {breadcrumbs.map((crumb, index) => (
          <li key={index}>
            {index === breadcrumbs.length - 1 ? (
              <span aria-current="page">{crumb.label}</span>
            ) : (
              <Link href={crumb.href}>{crumb.label}</Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
